<template>
  <footer class="l-footer" ref="footerInfoHeight">
    <div class="l-content">
      <div class="l-inner">
        <ul>
          <li class="l-footer-nav__item">
            <a
              href="https://castmeinfluencer.zendesk.com/hc/ja/requests/new"
              target="_blank"
            >
              お問い合わせ
            </a>
          </li>
          <li class="l-footer-nav__item" v-if="!isMaintenance">
            <a
              :href="$constants.loginSiteUrl + '/terms/service'"
              target="_blank"
            >
              インフルエンサー登録規約
            </a>
          </li>
          <li class="l-footer-nav__item" v-if="!isMaintenance">
            <a
              :href="$constants.loginSiteUrl + '/privacypolicy'"
              target="_blank"
            >
              プライバシーポリシー
            </a>
          </li>
          <li>
            <a :href="$constants.corporateSiteUrl" target="_blank"
              >運営会社情報</a
            >
          </li>
        </ul>
        <p class="l-footer__copy">Copyright © PLAN-B, Inc.</p>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  created() {
    // this.handleScroll();
  },
  mounted() {
    // scroll位置の取得
    // window.addEventListener('scroll', this.handleScroll);
    // window.addEventListener('resize', this.handleScroll);
  },
  beforeDestroy: function() {
    // window.removeEventListener('scroll', this.handleScroll);
    // window.removeEventListener('resize', this.handleScroll);
  },
  computed: {
    isMaintenance() {
      return this.$store.getters['view/isMaintenance'];
    }
  },
  methods: {
    handleScroll() {
      // let footerInfoHeight = this.$refs.footerInfoHeight.clientHeight;
      // console.log(footerInfoHeight);
      // this.$emit('footerInfoHeight', footerInfoHeight);
    }
  }
};
</script>
